import { Redirect, Route } from "react-router-dom";
import React from "react";

export const ProtectedRoute = ({ ...props }) => {
  if (!localStorage.getItem("token")) return <Redirect to={`/`} />;

  return <Route {...props} />;
};
